// i18n/enArticles.ts

export function enArticle(word: string): "a" | "an" {
  const vowelSoundRegex = /^[aeiou]/i;
  return vowelSoundRegex.test(word) ? "an" : "a";
}
